<mat-toolbar fxFlex="row" fxLayoutAlign="center" fxLayoutGap="0px" color="primary" class="header mat-elevation-z4">
  <button mat-icon-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <a mat-button routerLink="/profile" *ngIf="showLogo || !sidenav.opened">
    <img src="../../../assets/icons/logo.png" alt="Knowledge" style="height: 36px;"/>
  </a>
  <span fxFlex></span>
  <a mat-button href="https://www.youtube.com/channel/UCwXFVud1gmnbawdNxg_PRmA/videos" target="_blank"><mat-icon>help_center</mat-icon>
  </a>
<!--   <button mat-icon-button (click)="">
    <mat-icon>help_center</mat-icon>
  </button> -->
</mat-toolbar>
